(function () {
  var root = document.querySelector('[data-financing-drawer]');
  if (!root) return;

  var drawer = root.querySelector('[data-financing-drawer-panel]');
  var overlay = root.querySelector('[data-financing-drawer-overlay]');
  var closeBtn = root.querySelector('[data-financing-drawer-close]');
  var select = root.querySelector('[data-financing-select]');
  var resultAmount = root.querySelector('[data-financing-amount]');
  var teaserAmount = document.querySelector('[data-financing-teaser-amount]');

  if (!drawer || !overlay || !closeBtn) return;

  var factors = { 12: 1.05, 24: 1.10, 36: 1.15 };

  function getProductPrice() {
    var priceEl = document.querySelector('product-component .priceItem--regular');
    if (!priceEl) return 0;
    var text = priceEl.textContent.replace(/[^\d.,]/g, '').replace(/\./g, '').replace(',', '.');
    return parseFloat(text) || 0;
  }

  function formatMoney(amount) {
    var fmt = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '{{amount}} kr';
    var formatted = amount.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt.replace('{{amount}}', formatted)
              .replace('{{amount_no_decimals}}', Math.round(amount).toString())
              .replace('{{amount_with_comma_separator}}', formatted);
  }

  function calculate(months) {
    var price = getProductPrice();
    var factor = factors[months] || 1.05;
    return price / months * factor;
  }

  function updateResult() {
    var months = parseInt(select.value, 10);
    var monthly = calculate(months);
    if (resultAmount) resultAmount.textContent = formatMoney(monthly);
  }

  function updateTeaser() {
    if (!teaserAmount) return;
    var lowest = calculate(36);
    teaserAmount.textContent = formatMoney(lowest);
  }

  function setOpenState(isOpen) {
    drawer.setAttribute('data-open', isOpen ? 'true' : 'false');
    overlay.setAttribute('data-open', isOpen ? 'true' : 'false');
    drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    if (isOpen) {
      document.body.classList.add('financing-drawer-lock');
    } else {
      document.body.classList.remove('financing-drawer-lock');
    }
  }

  function openDrawer(e) {
    if (e) e.preventDefault();
    updateResult();
    setOpenState(true);
    closeBtn.focus();
  }

  function closeDrawer(e) {
    if (e) e.preventDefault();
    setOpenState(false);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-open-financing-drawer')) openDrawer(e);
  });

  var atcBtn = root.querySelector('[data-financing-atc]');

  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  function getRealAtcButton() {
    // The real add-to-cart lives in the product form (blocks/_product-buy-buttons.liquid).
    // Mirror the theme's sticky ATC, which proxies a click to this same button.
    return document.querySelector('[data-product-form] [data-action="add-to-cart"]');
  }

  if (atcBtn) {
    atcBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var realAtc = getRealAtcButton();
      if (realAtc && !realAtc.hasAttribute('disabled')) {
        realAtc.click();
      }
      // Close the financing drawer so the cart drawer (opened by the real ATC) is visible.
      closeDrawer(e);
    });
  }

  if (select) {
    select.addEventListener('change', updateResult);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') {
      closeDrawer(e);
    }
  });

  updateTeaser();

  var priceObserver = new MutationObserver(function () {
    updateTeaser();
    if (drawer.getAttribute('data-open') === 'true') updateResult();
  });
  var priceEl = document.querySelector('product-component .priceItem--regular');
  if (priceEl) priceObserver.observe(priceEl, { childList: true, characterData: true, subtree: true });
})();
